import React from "react";

/**
 * Percent-based clickable regions over a responsive image (same pattern as howtoPopup).
 * @param {{ top?: string, right?: string, bottom?: string, left?: string, width: string, height: string, onClick?: () => void, ariaLabel?: string, title?: string }} area
 */
export function ImageMapArea({ top, right, bottom, left, width, height, onClick, ariaLabel, title }) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      title={title}
      onClick={onClick}
      style={{
        position: "absolute",
        top,
        right,
        bottom,
        left,
        width,
        height,
        padding: 0,
        border: "none",
        background: "transparent",
        cursor: onClick ? "pointer" : "default",
        zIndex: 10,
      }}
    />
  );
}

export function ImageMapContainer({ children, style, className }) {
  return (
    <div
      className={className}
      style={{
        position: "relative",
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
